import { useCallback, useMemo } from 'react'
import { useGetZoneTemplatesQuery } from '../graphql/queries/getZoneTemplates.types'
import { defaultTemplate } from '../constants'
import { useLoading, useServerError } from 'shared/hooks'
import { LabelTemplate, LabelTemplateType } from 'shared/__gql-types'

type TemplateConfig = { [key in LabelTemplateType]?: LabelTemplate }

export const useZoneTemplates = (zoneId: string) => {
  const { data: zoneTemplatesResponse, error, loading } = useGetZoneTemplatesQuery({ variables: { id: zoneId } })

  const templateByType = useMemo((): TemplateConfig =>
    Object.values(LabelTemplateType).reduce((res, key) => ({
      ...res,
      [key]: (zoneTemplatesResponse?.getLabelTemplates ?? []).find((temp) => temp.template_type === key) ?? defaultTemplate[key]
    }), {}), [zoneTemplatesResponse])

  const templatesList = Object.values(templateByType)

  const getTemplateByType = useCallback((name: LabelTemplateType) => templateByType[name]?.template ?? '', [templateByType])

  useLoading({ isLoading: loading })
  useServerError([error])

  return {
    zoneTemplatesResponse,
    getTemplateByType,
    templatesList,
    error,
    loading
  }
}
